import api from "./api.config";

// Panelist APIs
export const panelistAPI = {
  // Get all available members for a panel (excluding already selected)
  getPanelMembers: async (panelId) => {
    try {
      const response = await api.get(`/panelists/${panelId}/members`);
      return response.data;
    } catch (error) {
      console.error("Error fetching panel members:", error);
      throw error;
    }
  },

  // Get currently selected panelists for a panel
  getSelectedPanelists: async (panelId) => {
    try {
      const response = await api.get(`/panelists/${panelId}/panelists`);
      return response.data;
    } catch (error) {
      console.error("Error fetching selected panelists:", error);
      throw error;
    }
  },

  // Add a panelist to a panel
  addPanelist: async (panelId, data) => {
    try {
      const response = await api.post(`/panelists/${panelId}/panelists`, data);
      return response.data;
    } catch (error) {
      console.error("Error adding panelist:", error);
      throw error;
    }
  },

  // Remove a panelist from a panel
  removePanelist: async (panelId, panelistId, data = {}) => {
    try {
      const response = await api.delete(
        `/panelists/${panelId}/panelists/${panelistId}`,
        { data }
      );
      return response.data;
    } catch (error) {
      console.error("Error removing panelist:", error);
      throw error;
    }
  },

  // Update panelist status
  updatePanelistStatus: async (
    panelId,
    panelistId,
    status,
    contribution,
    feedback
  ) => {
    try {
      const response = await api.put(
        `/panelists/${panelId}/panelists/${panelistId}`,
        {
          status,
          contribution,
          feedback,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating panelist:", error);
      throw error;
    }
  },

  // Get all cadres with conflict of interest status (for Members tab)
  getAllCadres: async () => {
    try {
      const response = await api.get("/panelists/cadres");
      return response.data;
    } catch (error) {
      console.error("Error fetching all cadres:", error);
      throw error;
    }
  },

  // Get CADRE_MEMBER users related to a specific panel
  getPanelCadres: async (panelId) => {
    try {
      const response = await api.get(`/panelists/${panelId}/cadres`);
      return response.data;
    } catch (error) {
      console.error("Error fetching panel cadres:", error);
      throw error;
    }
  },

  // Get available panelists (only NO conflict of interest) for a panel
  getAvailablePanelists: async (panelId) => {
    try {
      const response = await api.get(`/panelists/${panelId}/available`);
      return response.data;
    } catch (error) {
      console.error("Error fetching available panelists:", error);
      throw error;
    }
  },
};
